import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

const vehiclesSlice = createSlice({
	name: 'vehicles',
	initialState,
	reducers: {
		setVehicles: (state, action) => {
			return Array.isArray(action.payload) ? action.payload : state;
		},
		removeVehicle: (state, action) => {
			return state.filter((vehicle) => vehicle.uuid !== action.payload);
		}
	}
});

export const { setVehicles, removeVehicle } = vehiclesSlice.actions;
export default vehiclesSlice.reducer;
